import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";

/**
 * Chaves de skills aceitas pelo backend: receptionist, faq, ticket_seller.
 * Ordem usada como order_index ao enviar.
 */
export const SKILL_OPTIONS = [
  { skill_key: "receptionist", label: "Recepcionista", desc: "Atende e direciona o visitante" },
  { skill_key: "faq", label: "Perguntas frequentes", desc: "Responde dúvidas comuns" },
  { skill_key: "ticket_seller", label: "Venda de ingressos", desc: "Ajuda na compra de ingressos" },
];

/**
 * value: array de { skill_key, config?, order_index? } (formato backend)
 * onChange: (array) => void
 */
const SkillSelector = ({ value = [], onChange, disabled = false }) => {
  const selectedKeys = Array.isArray(value)
    ? value.map((s) => (typeof s === "string" ? s : s?.skill_key)).filter(Boolean)
    : [];

  const toggle = (skill_key) => {
    if (disabled) return;
    const checked = selectedKeys.includes(skill_key);
    const current = Array.isArray(value) ? value : [];
    if (checked) {
      const filtered = current.filter((s) => (typeof s === "object" ? s.skill_key : s) !== skill_key);
      filtered.forEach((s, i) => {
        if (typeof s === "object") s.order_index = i;
      });
      onChange?.(filtered);
    } else {
      const existing = current.find((s) => (typeof s === "object" ? s.skill_key : s) === skill_key);
      if (existing) return;
      const opt = SKILL_OPTIONS.find((o) => o.skill_key === skill_key);
      const order_index = opt ? SKILL_OPTIONS.indexOf(opt) : current.length;
      const next = [...current, { skill_key, config: "", order_index }];
      next.sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0));
      onChange?.(next);
    }
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Escolha as funções do agente (clique para ativar ou desativar):
      </Typography>
      <Stack direction="row" flexWrap="wrap" useFlexGap spacing={1}>
        {SKILL_OPTIONS.map(({ skill_key, label, desc }) => {
          const selected = selectedKeys.includes(skill_key);
          return (
            <Chip
              key={skill_key}
              label={label}
              onClick={() => toggle(skill_key)}
              color={selected ? "primary" : "default"}
              variant={selected ? "filled" : "outlined"}
              disabled={disabled}
              sx={{ fontWeight: 500 }}
              title={desc}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

export default SkillSelector;
